import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";

import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { Link, withRouter } from "react-router-dom";
import { OBSERVATION_CATEGORY } from "./ObservationTab";

import EvidenceDetailsInfo from "../../IncidentManagement/EvidenceDetailsInfo";
import { OBSERVATION_TYPE, VFL_STATUS } from "../CONSTANTS";
import {
  useContractorDropdown,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { TRAINEE_TYPE } from "../../TrainingManagement/CONSTANTS";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { getContractor } from "app/_services/Contractor/ContractorService";

const VFLDetailsInfo = ({ form = {} }) => {
  const [, employeesOption] = useEmployeeDropdown();

  const [, contractorPersonsOption] = useContractorPersonDropdown();
  const [contractors] = useContractorDropdown();

  let capaFlag = false;
  for (const iterator of form?.vflObservations || []) {
    if (iterator.allCapa.length > 0) capaFlag = true;
  }

  const vflScheduledFlag = form?.schedularData ? true : false;
  const vflAssignedFlag = form?.vflAssignedDate ? true : false;
  const vflExecutedFlag = form.vflExecutionDateTime ? true : false;
  const vflCompletedFlag = form.vflStatus === VFL_STATUS.completed ? true : false;

  return (
    <div className="rightIncidentCard">
      <Accordion defaultActiveKey="0" className="incidentDetailAcc">
        <div>
          <Accordion.Toggle as={Card.Header} eventKey="0" className="satyamClass">
            Info
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">VFL ID:</span>
                  <span className="rightData">{form?.vflId}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">VFL Executive (Team Leader)</span>
                  <span className="rightData">{`${userDropdownLabel(
                    form?.vflOfficerData
                  )}`}</span>
                </li>
                <li>
                  <span className="txtgrey">VFL Schedule Date:</span>
                  <span className="rightData">
                    {DDMMYYYYFormat(form?.vflScheduledDateTime)}
                  </span>
                </li>
                {form?.contractorInvolved ? (
                  <li>
                    <span className="txtgrey">Contractor Involved:</span>
                    <span className="rightData">
                      {
                        contractors.find((d) => d.id === form?.contractorsId)
                          ?.contractorLegalEntity
                      }
                    </span>
                  </li>
                ) : (
                  ""
                )}
                <li>
                  <span className="txtgrey">Mine Name:</span>
                  <span className="rightData">{form?.siteData?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Regional Office:</span>
                  <span className="rightData">{form?.siteData?.parentSite?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Department:</span>
                  <span className="rightData">{form?.departmentId}</span>
                </li>

                <li>
                  <span className="txtgrey">Area of Operation:</span>
                  <span className="rightData">{form?.ehs_area_of_operations?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Sub Area of Operation:</span>
                  <span className="rightData">
                    {form?.subAreaId === 0
                      ? "Other"
                      : (form?.ehs_area_of_operations?.subAreaOfOperation || []).find(
                          (d) => d.id === form?.subAreaId
                        )?.name}
                  </span>
                </li>
                {form?.subAreaId === 0 && (
                  <li>
                    <span className="txtgrey">Other Sub Area:</span>
                    <span className="rightData">{form?.otherSubArea}</span>
                  </li>
                )}
                <li>
                  <span className="txtgrey">Activity:</span>
                  <span className="rightData">{form?.ehs_activity?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Sub Activity :</span>
                  <span className="rightData">
                    {
                      (form?.ehs_activity?.subActivity || []).find(
                        (d) => d.id === form?.subActivityId
                      )?.name
                    }
                  </span>
                </li>
                <li>
                  <span className="txtgrey">Location ID:</span>
                  <span className="rightData">{form?.siteData?.siteId}</span>
                </li>
                <li>
                  <span className="txtgrey">RO ID:</span>
                  <span className="rightData">{form?.siteData?.parentSite?.siteId}</span>
                </li>
                <li>
                  <span className="txtgrey">VFL System Time Stamp:</span>
                  <span className="rightData">
                    {DDMMYYYYHHMMAFormat(form?.createdAt)}
                  </span>
                </li>
                <li>
                  <span className="txtgrey">State:</span>
                  <span className="rightData">{form?.siteData?.state?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Country:</span>
                  <span className="rightData">
                    {form?.siteData?.state?.country_master?.name}
                  </span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">VFL Scheduled By</span>
                  <span className="rightData">{`${userDropdownLabel(
                    form?.schedularData
                  )}`}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">VFL Description</span>
                  <span className="rightData">{form?.description || ""}</span>
                </li>
                {form.vflCompletionDateTime && (
                  <li>
                    <span className="txtgrey">VFL Conducted On:</span>
                    <span className="rightData">
                      {formatDDMMYYYYbyYYYYMMDD(form.vflCompletionDateTime)}
                    </span>
                  </li>
                )}
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </div>

        {vflExecutedFlag && (
          <>
            <div>
              <Accordion.Toggle as={Card.Header} eventKey="1">
                Workmen Interaction
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <ul style={{ listStyle: "none" }} className="p-0">
                    <li>
                      <span className="txtgrey">Brief about on-going Operations:</span>
                      <span className="rightData">
                        {form?.workmen_interactions?.operationBrief}
                      </span>
                    </li>
                    <li>
                      <span className="txtgrey">
                        Understanding of the Workmen on Safety:
                      </span>
                      <span className="rightData">
                        {form?.workmen_interactions?.workmenUnderstandingOnSafety}
                      </span>
                    </li>
                    <li>
                      <span className="txtgrey">
                        Safety Briefing Provided to Workmen:
                      </span>
                      <span className="rightData">
                        {form?.workmen_interactions?.safetyProvidedToWorkmen}
                      </span>
                    </li>
                    <li>
                      <span className="txtgrey">Other Remarks:</span>
                      <span className="rightData">
                        {form?.workmen_interactions?.remark}
                      </span>
                    </li>
                    <li>
                      <span className="txtgrey">
                        Number of Workpersons Interacted with:
                      </span>
                      <span className="rightData">
                        {form?.workmen_interactions?.numberOfWorkpersons}
                      </span>
                    </li>
                  </ul>
                  <div>Key Workmen Interacted with</div>
                  {form?.workmen_interactions?.workmenInteractedWith?.map(
                    (data, index) => {
                      const traineeOption = (() => {
                        switch (data?.type) {
                          case "employee":
                            return employeesOption;
                          case "contractorPerson":
                            return contractorPersonsOption;

                          default:
                            return [];
                        }
                      })();

                      return (
                        <div key={index} className="detailsGroup">
                          <ul style={{ listStyle: "none" }} className="p-0">
                            <li>
                              <span className="txtgrey">Type:</span>
                              <span className="rightData">{TRAINEE_TYPE[data.type]}</span>
                            </li>
                            <li>
                              <span className="txtgrey">Name:</span>
                              <span className="rightData">
                                {
                                  traineeOption?.find((d) => +d.id === +data.userId)
                                    ?.label
                                }
                              </span>
                            </li>
                            {/* <li>
                            <span className="txtgrey">Brief about on-going Operations:</span>
                            <span className="rightData">{data.operationBrief}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Understanding of the Workmen on Safety:</span>
                            <span className="rightData">{data.workmenUnderstandingOnSafety}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Safety Briefing Provided to Workmen:</span>
                            <span className="rightData">{data.safetyProvidedToWorkmen}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Other Remarks:</span>
                            <span className="rightData">{data.remark}</span>
                          </li> */}
                          </ul>
                        </div>
                      );
                    }
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>

            <div>
              <Accordion.Toggle as={Card.Header} eventKey="2">
                Observations
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  {!form?.vflObservations?.length ? (
                    <div className="text-danger">Not Applicable</div>
                  ) : (
                    form?.vflObservations.map((data, index) => (
                      <div key={index} className="detailsGroup">
                        <ul style={{ listStyle: "none" }} className="p-0">
                          <li>
                            <span className="txtgrey">Observation:</span>
                            <span className="rightData">
                              {data.observation || "Not Applicable"}
                            </span>
                          </li>
                          <li>
                            <span className="txtgrey">Type:</span>
                            <span className="rightData">
                              {OBSERVATION_TYPE.find((d) => d.id === data.type)?.label ||
                                "Not Applicable"}
                            </span>
                          </li>
                          <li>
                            <span className="txtgrey">Category:</span>
                            <span className="rightData">
                              {data?.categoryData?.name || "Not Applicable"}
                            </span>
                          </li>
                          <li>
                            <span className="txtgrey">Sub-Category:</span>
                            <span className="rightData">
                              {(data?.categoryData?.subCategory || []).find(
                                (d) => d.id === +data?.subCategory
                              )?.name || "Not Applicable"}
                            </span>
                          </li>
                          <li>
                            <span className="txtgrey">Potential:</span>
                            <span className="rightData">
                              {data.potential || "Not Applicable"}
                            </span>
                          </li>
                          <li>
                            <span className="txtgrey">Severity:</span>
                            <span className="rightData">
                              {data.severity || "Not Applicable"}
                            </span>
                          </li>
                        </ul>
                      </div>
                    ))
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>

            <div>
              <Accordion.Toggle as={Card.Header} eventKey="3">
                Evidence
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  {form?.evidences?.length ? (
                    form?.evidences.map((data) => (
                      <EvidenceDetailsInfo isDocumentObj key={data.id} {...data} />
                    ))
                  ) : (
                    <div className="text-danger">Not Applicable</div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>

            <div>
              <Accordion.Toggle as={Card.Header} eventKey="4">
                Capa
                <span style={{ float: "right" }}>
                  <MdKeyboardArrowRight />
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  {!capaFlag ? (
                    <div className="text-danger">Not Applicable</div>
                  ) : (
                    form?.vflObservations
                      .filter((d) => !["safeCondition", "safeAct"].includes(d.type))
                      .map((observation) => {
                        return (
                          <div key={observation.id}>
                            <h4>
                              {
                                OBSERVATION_CATEGORY.find(
                                  (data) => data.id === observation.type
                                )?.label
                              }
                            </h4>
                            {observation?.allCapa.map((data, index) => (
                              <div key={data.id} className="detailsGroup">
                                <ul style={{ listStyle: "none" }} className="p-0">
                                  <li>
                                    <span className="txtgrey">CAPA Id:</span>
                                    <span className="rightData">
                                      <Link
                                        target="_blank"
                                        to={`/health-safety-and-environment/capa-management/manage-capa/update/${data.id}`}
                                      >
                                        {data.capaId}
                                      </Link>{" "}
                                    </span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">CAPA Type:</span>
                                    <span className="rightData">{data.capaType}</span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">CAPA Description:</span>
                                    <span className="rightData">{data.solution}</span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">Area:</span>
                                    <span className="rightData">
                                      {data?.workArea?.name}
                                    </span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">Sub Area:</span>
                                    <span className="rightData">
                                      {data?.subAreaId === 999
                                        ? "Other"
                                        : (data?.workArea?.subAreaOfOperation || []).find(
                                            (d) => d.id === data?.subAreaId
                                          )?.name}
                                    </span>
                                  </li>
                                  {data?.subAreaId === 999 && (
                                    <li>
                                      <span className="txtgrey">Other Sub Area:</span>
                                      <span className="rightData">
                                        {data?.otherSubArea}
                                      </span>
                                    </li>
                                  )}
                                  <li>
                                    <span className="txtgrey">CAPA Owner:</span>
                                    <span className="rightData">
                                      {userDropdownLabel(data.owner)}
                                    </span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">Priority:</span>
                                    <span className="rightData">{data.priority}</span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">Due Date:</span>
                                    <span className="rightData">
                                      {DDMMYYYYFormat(data.dueDate)}
                                    </span>
                                  </li>
                                  <li>
                                    <span className="txtgrey">Status:</span>
                                    <span className="rightData">{data.capaStatus}</span>
                                  </li>
                                  {data.completionDate && (
                                    <li>
                                      <span className="txtgrey">Completion Date:</span>
                                      <span className="rightData">
                                        {DDMMYYYYFormat(data.completionDate)}
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            ))}
                          </div>
                        );
                      })
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </div>
          </>
        )}
      </Accordion>
    </div>
  );
};

export default withRouter(VFLDetailsInfo);
